import { userProfileStore } from 'features/chat/MainContent/store';
import { useEffect } from 'react';
import If from 'global/ErrorHandlers/If';
import SectionItem from './SectionItem';
import SectionList from './SectionList';
import SocialMedia from './SocialMedia';

interface SingleRecipientProps {
  selectedReceiverId: Array<number>;
  onSelectReceiver: (receiver: any, id: number) => void;
  recipientName: string;
  message?: string;
}

export default function SingleRecipient({
  selectedReceiverId,
  onSelectReceiver,
  recipientName,
  message: urlToShare,
}: SingleRecipientProps) {
  // user profile
  const getRecipient = userProfileStore((store) => store.fetchUserProfile);
  const recipientRecords = userProfileStore((store) => store.data);

  const recipient = recipientRecords[recipientName];

  const data = {
    id: recipient?.user_id,
    type: 'RECEIVER_TYPE_USER',
    name: recipient?.profile.fullname,
    avatar: recipient?.profile.avatar_urls.thumbnail_url,
    shortName: recipient?.profile.username,
  };

  useEffect(() => {
    getRecipient(recipientName);
  }, []);

  return (
    <SectionList title="Share to">
      <If condition={!!data}>
        <SectionItem
          key={data.id}
          src={data.avatar}
          caption={data.name || ''}
          onClick={() => onSelectReceiver(data, data.id)}
          selected={selectedReceiverId.includes(data.id)}
          data={data}
          isAvatar
        />
      </If>
      <SocialMedia linkUrl={urlToShare} />
    </SectionList>
  );
}
